var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExitFullScreen = function SvgExitFullScreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 22"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M17.417 8.25v1.833h-4.584a.917.917 0 0 1-.916-.916V4.583h1.833V8.25zM4.583 8.25v1.833h4.584c.506 0 .916-.41.916-.916V4.583H8.25V8.25zM17.417 13.75v-1.833h-4.584a.917.917 0 0 0-.916.916v4.584h1.833V13.75zM4.583 13.75v-1.833h4.584c.506 0 .916.41.916.916v4.584H8.25V13.75z",
    clipRule: "evenodd"
  })));
};
export default SvgExitFullScreen;